(function () {
  var BUNDLE_QTY = 4;
  var selected = new Set();

  var grid = document.getElementById('ffb-bundle-grid');
  var countLabel = document.getElementById('ffb-count');
  var progressBar = document.getElementById('ffb-progress-bar');
  var addBundleBtn = document.getElementById('ffb-add-bundle');

  function updateBundleUI() {
    var count = selected.size;
    countLabel.textContent = count + ' of ' + BUNDLE_QTY + ' selected';
    progressBar.style.width = Math.min((count / BUNDLE_QTY) * 100, 100) + '%';

    if (count === BUNDLE_QTY) {
      addBundleBtn.disabled = false;
      addBundleBtn.textContent = 'Add bundle to cart';
    } else {
      addBundleBtn.disabled = true;
      var remaining = BUNDLE_QTY - count;
      addBundleBtn.textContent = count === 0
        ? 'Select ' + BUNDLE_QTY + ' to build your bundle'
        : 'Select ' + remaining + ' more to complete your bundle';
    }
  }

  if (grid) {
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.ffb-bundle-item');
      if (!card || card.disabled) return;

      var variantId = card.getAttribute('data-variant-id');

      if (selected.has(variantId)) {
        selected.delete(variantId);
        card.classList.remove('is-selected');
      } else {
        if (selected.size >= BUNDLE_QTY) return;
        selected.add(variantId);
        card.classList.add('is-selected');
      }
      updateBundleUI();
    });
  }

  if (addBundleBtn) {
    addBundleBtn.addEventListener('click', function () {
      if (selected.size !== BUNDLE_QTY) return;

      var items = Array.from(selected).map(function (id) {
        return { id: id, quantity: 1 };
      });

      addBundleBtn.disabled = true;
      addBundleBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error(err);
          addBundleBtn.disabled = false;
          addBundleBtn.textContent = 'Something went wrong — try again';
        });
    });
  }

  document.querySelectorAll('.ffb-card-header[data-toggle]').forEach(function (header) {
    header.addEventListener('click', function () {
      var id = header.getAttribute('data-toggle');
      var detail = document.getElementById('ffb-detail-' + id);
      if (!detail) return;
      var isOpen = detail.classList.contains('is-open');
      detail.classList.toggle('is-open', !isOpen);
    });
  });

document.querySelectorAll('.ffb-qty-input').forEach(function (input) {
    input.addEventListener('click', function (e) { e.stopPropagation(); });

    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');
      updateQtyTotal(input);
    });

    input.addEventListener('blur', function () {
      var max = parseInt(input.getAttribute('max'), 10);
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      if (!isNaN(max) && qty > max) qty = max;
      input.value = qty;
      updateQtyTotal(input);
    });
  });

  function updateQtyTotal(input) {
    var qty = parseInt(input.value, 10) || 1;
    var productId = input.id.replace('ffb-qty-', '');
    var addBtn = document.querySelector('.ffb-add-single[data-product-id="' + productId + '"]');
    var totalEl = document.getElementById('ffb-total-' + productId);
    if (addBtn && totalEl) {
      var price = parseFloat(addBtn.getAttribute('data-price'));
      totalEl.textContent = '$' + (qty * price).toFixed(2);
    }
  }

  document.querySelectorAll('.ffb-add-single').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      var productId = btn.getAttribute('data-product-id');
      var qtyInput = document.getElementById('ffb-qty-' + productId);
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var originalText = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.disabled = false;
            btn.innerHTML = originalText;
          }, 1500);
        })
        .catch(function (err) {
          console.error(err);
          btn.disabled = false;
          btn.textContent = 'Try again';
        });
    });
  });
document.querySelectorAll('.ffb-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var input = document.getElementById(btn.getAttribute('data-target'));
      if (!input) return;
      var max = parseInt(input.getAttribute('max'), 10);
      var qty = parseInt(input.value, 10) || 1;

      if (btn.classList.contains('ffb-qty-plus')) {
        qty = qty + 1;
        if (!isNaN(max) && qty > max) qty = max;
      } else {
        qty = qty - 1;
        if (qty < 1) qty = 1;
      }
      input.value = qty;
      updateQtyTotal(input);
    });
  });
  updateBundleUI();
})();
